import FiberManualRecordIcon from '@mui/icons-material/FiberManualRecord';
import {
  ActionsDropdownConfig,
  fullClassName,
  Render,
} from '@techsharegov/react-ui';
import { Fragment, HTMLProps, ReactNode } from 'react';
import { SecondaryNavigationPillBar, SecondaryNavigationPillBarProps } from 'Components/Navigation';

type PageHeaderProps = HTMLProps<HTMLDivElement> & {
  title?: string;
  dropdownConfig?: ActionsDropdownConfig;
  tall?: boolean;
};

export type TaskHeaderProps = PageHeaderProps & {
  saveButtonText?: string;
  disableSaveButton?: boolean;
  customButtons?: ReactNode;
  tall?: boolean;
};

const HeaderBullet: React.FC = () => (
  <div className="bullet-separator">
    <FiberManualRecordIcon className="font-size-tiny" />
  </div>
);

export type HeaderBulletedListProps = {
  list: (string | undefined)[];
  header?: boolean;
  wrapperProps?: HTMLProps<HTMLDivElement>;
};

export const HeaderBulletedList: React.FC<HeaderBulletedListProps> = ({
  list,
  header,
  wrapperProps,
}) => {
  return (
    <div
      className={fullClassName('flex-vertical-center', wrapperProps?.className)}
      {...wrapperProps}
    >
      {list
        .filter((item) => item && item.length > 0)
        .map((item, index) => (
          <Fragment key={index}>
            <Render condition={index !== 0}>
              <HeaderBullet />
            </Render>
            <span
              className={header ? '' : 'font-secondary-bold header-size-small'}
            >
              {item}
            </span>
          </Fragment>
        ))}
    </div>
  );
};

export type BulletedHeadingProps = {
  mainBulletItems: (string | undefined)[];
  subBulletItems?: (string | undefined)[];
  smallerMainBullets?: boolean;
};

export const BulletedHeading: React.FC<BulletedHeadingProps> = ({
  mainBulletItems,
  subBulletItems = [],
  smallerMainBullets,
}) => {
  const MainBulletWrapper = smallerMainBullets ? 'h2' : 'h1';

  return (
    <div className="flex-column sub-header-text flex-grow">
      <div className="flex-normal">
        <MainBulletWrapper>
          <HeaderBulletedList header list={mainBulletItems} />
        </MainBulletWrapper>
      </div>
      <HeaderBulletedList list={subBulletItems} />
    </div>
  );
};


export type SecondaryHeaderProps = PageHeaderProps &
  SecondaryNavigationPillBarProps;

export const SecondaryHeader: React.FC<SecondaryHeaderProps> = ({
  children,
  title,
  className,
  ...pillBarProps
}) => {

  return (
    <div
      className={fullClassName(
        'flex-column border-bottom-light page-header bg-light overflow-auto',
        className
      )}
    >
      <div className="secondary-header-title">
        {title ? <h2>{title}</h2> : children}
      </div>
      <SecondaryNavigationPillBar {...pillBarProps} />
    </div>
  );
};
